import React from "react";
import PropTypes from "prop-types";
import TextFlag from "components/atoms/TextFlag";
import classnames from "classnames";

const ProductTitle = (props) => {
  const {
    className,
    isNew = false,
    displayTitleHeading,
    displayTitleSubheading,
    displayTitleInfo,
    detailUri,
    forwardRef,
  } = props;
  const componentBaseClass = "sal-product-title";
  const componentClass = classnames(componentBaseClass, className);

  const [secondaryTitle, tertiaryTitle] = displayTitleSubheading || [];
  const [titleInfoPrimary, titleInfoSecondary] = displayTitleInfo || [];

  return (
    <a
      className={componentBaseClass + "__holder"}
      href={detailUri}
      rel="follow"
      ref={forwardRef}
    >
      <div className={componentClass}>
        <h1>
          <span className={componentBaseClass + "__primary"}>
            {isNew && (
              <TextFlag
                className={componentBaseClass + "__is-new"}
                text={"NEU"}
              />
            )}
            {displayTitleHeading}
          </span>
          {secondaryTitle && (
            <span className={componentBaseClass + "__secondary"}>
              {secondaryTitle}
            </span>
          )}
          {tertiaryTitle && (
            <span className={componentBaseClass + "__tertiary"}>
              {tertiaryTitle}
            </span>
          )}
        </h1>
        {titleInfoPrimary && (
          <div className={componentBaseClass + "__info-primary"}>
            {titleInfoPrimary}
          </div>
        )}
        {titleInfoSecondary && (
          <div className={componentBaseClass + "__info-secondary"}>
            {titleInfoSecondary}
          </div>
        )}
      </div>
    </a>
  );
};

ProductTitle.propTypes = {
  className: PropTypes.string,
  displayTitleHeading: PropTypes.string.isRequired,
  displayTitleSubheading: PropTypes.arrayOf(PropTypes.string),
  displayTitleInfo: PropTypes.arrayOf(PropTypes.string),
  isNew: PropTypes.bool,
  detailUri: PropTypes.string,
  forwardRef: PropTypes.object,
};

export default ProductTitle;
